import bannerZeroCost from "../Assests/HerobelowBanners/banner-zero-cost-optimized.jpg";
import bannerChennaiCab from "../Assests/HerobelowBanners/banner-chennai-cab-hd-optimized.jpg";
import bannerFreeCancellation from "../Assests/HerobelowBanners/banner-free-cancellation-optimized.jpg";

const banners = [
  {
    src: bannerZeroCost,
    alt: "Book now at zero cost",
  },
  {
    src: bannerChennaiCab,
    alt: "Exclusive Chennai cab packages",
  },
  {
    src: bannerFreeCancellation,
    alt: "Free cancellations up to 1 hour before your trip",
  },
];

export default function HeroBelowBanners() {
  return (
    <section className="hero-below-banners" aria-label="BookinIndia offers">
      <style>{`
        .hero-below-banners {
          background: #f8f8f8;
          padding: 24px 16px;
          box-sizing: border-box;
        }

        .hero-below-banners__grid {
          width: 100%;
          max-width: 1180px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 16px;
        }

        .hero-below-banners__item {
          display: block;
          border-radius: 18px;
          overflow: hidden;
          background: #fff;
          border: 1px solid #ebebeb;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
          aspect-ratio: 2.16 / 1;
        }

        .hero-below-banners__item img {
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
        }

        @media (max-width: 900px) {
          .hero-below-banners {
            padding: 8px 16px 10px;
          }

          .hero-below-banners__grid {
            display: flex;
            gap: 10px;
            overflow-x: auto;
            max-width: 430px;
            scroll-snap-type: x mandatory;
            scrollbar-width: none;
          }

          .hero-below-banners__grid::-webkit-scrollbar {
            display: none;
          }

          .hero-below-banners__item {
            min-width: 82%;
            border-radius: 14px;
            aspect-ratio: 2.16 / 1;
            scroll-snap-align: start;
          }
        }
      `}</style>

      <div className="hero-below-banners__grid">
        {banners.map((banner) => (
          <div className="hero-below-banners__item" key={banner.alt}>
            <img 
              src={banner.src} 
              alt={banner.alt} 
              loading="eager" 
              fetchPriority="high"
              decoding="async"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
